/**
 * Note: the locale property gets converted to an object with the following
 * format when it gets loaded into the redux store server side.
 * locale: { canonical: 'en_US', display: 'en-us' }
 * The format of locale.display depends on where the app is running.
 * IDs can be found here:
 * https://confluence.expedia.biz/display/SEM/Analysis+of+%5BDSA+Feeds%5D+Dev+work%3A+Updating+The+Multi+Lang+Id+to+POSa+Specific+Ids+in+Our+Systems?preview=%2F716866651%2F715891339%2FExpedia+PoSa+and+Language+id+Mapping.xlsx
 */
const languageList = [
    { displayName: 'English (US)', locale: 'en_US', langId: 1033 },
    { displayName: 'Español (España)', locale: 'es_ES', langId: 3082 },
    { displayName: 'Italiano', locale: 'it_IT', langId: 1040 },
    { displayName: 'Français', locale: 'fr_FR', langId: 1036 },
    { displayName: 'Français (Canadien)', locale: 'fr_CA', langId: 3084 },
    { displayName: 'Deutsch', locale: 'de_DE', langId: 1031 },
    { displayName: 'Deutsch (AT)', locale: 'de_AT', langId: 3079 },
    { displayName: 'Русский', locale: 'ru_RU', langId: 1049 },
    { displayName: 'Português (Brasileiro)', locale: 'pt_BR', langId: 1046 },
    { displayName: '日本語', locale: 'ja_JP', langId: 1041 },
    { displayName: '한국어', locale: 'ko_KR', langId: 1042 },
    { displayName: 'Tiếng Việt', locale: 'vi_VN', langId: 1066 },
    { displayName: '简体中文', locale: 'zh_CN', langId: 2052 },
    { displayName: '繁體中文 (台灣)', locale: 'zh_TW', langId: 1028 },
    { displayName: '繁體中文', locale: 'zh_HK', langId: 3076 },
    { displayName: 'Türkçe', locale: 'tr_TR', langId: 1055 },
    { displayName: 'Nederlands', locale: 'nl_NL', langId: 1043 },
    { displayName: 'ภาษาไทย', locale: 'th_TH', langId: 1054 },
    { displayName: 'Ελληνικά', locale: 'el_GR', langId: 1032 },
    { displayName: 'Português (Portugal)', locale: 'pt_PT', langId: 2070 },
    { displayName: 'English (UK)', locale: 'en_GB', langId: 2057 },
    { displayName: 'English (AU)', locale: 'en_AU', langId: 2057 }, // using langId for en_GB
    { displayName: 'English (NZ)', locale: 'en_NZ', langId: 2057 }, // using langId for en_GB
    { displayName: 'English (LK)', locale: 'en_LK', langId: 2057 }, // using langId for en_GB
    { displayName: 'English (SG)', locale: 'en_SG', langId: 2057 }, // using langId for en_GB
    { displayName: 'English (CA)', locale: 'en_CA', langId: 4105 },
    { displayName: 'Svenska', locale: 'sv_SE', langId: 1053 },
    { displayName: 'Polski', locale: 'pl_PL', langId: 1045 },
    { displayName: 'Norsk, bokmål', locale: 'nb_NO', langId: 1044 },
    { displayName: 'Hrvatski', locale: 'hr_HR', langId: 1050 },
    { displayName: 'Dansk', locale: 'da_DK', langId: 1030 },
    { displayName: 'Čeština', locale: 'fi_FI', langId: 1035 },
    { displayName: 'Suomi', locale: 'cs_CZ', langId: 1029 },
    { displayName: 'Magyar', locale: 'hu_HU', langId: 1038 },
    { displayName: 'العربية', locale: 'ar_SA', langId: 1025 },
    { displayName: 'עברית', locale: 'he_IL', langId: 1037 },
    { displayName: 'México', locale: 'es_XL', langId: 22538 }
];

const knownUnsupportedLangs = {
    // not sure if this is correct, as spain might be under european regulations
    // that mexico is not subjected to
    es_MX: 'es_ES'
};
const mpaasCanonicalLangs = {
    'no-no': 'nb_NO'
};

const mpassDisplaysLangs = {
    'en-sg': 'en_SG',
    'no-no': 'nb_NO'
};

const mpassLangProperties = {
    en_SG: 'en_GB',
    no_NO: 'nb_NO'
};

const langIdOnLocale = (locale) => {
    let langVal = '';
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < languageList.length; i++) {
        if (languageList[i].locale === locale) {
            langVal = languageList[i].langId;
            break;
        }
    }
    return langVal;
};

export {
    // eslint-disable-next-line import/prefer-default-export
    languageList,
    mpaasCanonicalLangs,
    mpassDisplaysLangs,
    mpassLangProperties,
    langIdOnLocale,
    knownUnsupportedLangs
};
